import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { CurrencyFormatPipe } from '../../../shared/pipes/currency-format.pipe';
import { MatFormField } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { InfoBulleComponent } from '../../info-bulle/info-bulle.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'acs-deductible-option-section',
  imports: [
    TranslatePipe,
    CurrencyFormatPipe,
    MatFormField,
    MatSelect,
    MatOption,
    InfoBulleComponent,
    ReactiveFormsModule
  ],
  templateUrl: './deductible-option-section.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeductibleOptionSectionComponent {
  @Input({ required: true }) fc!: FormControl;

  protected readonly deductibles: number[] = [500, 1000, 5000, 10000];
}
